<app-modal
  [isActive]="isActive"
  [showCloseFooter]="true"
  [showAcceptFooter]="true"
  [acceptFooterDisabled]="!form.valid"
  (acceptState)="sendAcceptModal()"
  (modalState)="closeModal.emit(true)"
>
  <p class="modal-card-title" modal-title>
    Infant Reasignation - <span class="is-capitalized">{{ name | lowercase }}</span>
  </p>

  <div modal-content>
    <div class="container pt-4" *ngIf="availableAdults?.length < 1">
      <div class="columns mb-1pt">
        <div class="column has-text-centered">
          <div class="icon is-large">
            <em class="mdi mdi-alert-circle mdi-48px has-text-grey"></em>
          </div>
        </div>
      </div>
      <app-title
        class="is-block has-text-centered"
        [medium]="true"
        title="There is not available adults"
      >
      </app-title>
    </div>

    <div *ngIf="availableAdults?.length > 0">
      <form [formGroup]="form">
        <div class="top-container">
          <div class="icon-container">
            <div class="icon is-large">
              <em class="mdi mdi-human-greeting has-text-primary mdi-48px"></em>
            </div>
          </div>

          <div>
            <p>{{ 'itinerary-info.passengers-info.current-responsibe-adult' | translate }}:</p>

            <p class="clear-text">
              {{ adultInCharge | titlecase }}
            </p>
          </div>
        </div>

        <div class="bottom-container">
          <p>{{ 'itinerary-info.passengers-info.new-responsibe-adult' | translate }}:</p>

          <app-input-select
            [form]="form"
            inputName="toAdult"
            id="toAdult"
            [placeholderDisabled]="false"
            [simple]="true"
            [values]="availableAdultsList"
            placeholder="Please select an adult"
          >
          </app-input-select>
        </div>
      </form>
    </div>
  </div>
</app-modal>
